import { $httpCampaign } from '@/plugins/axios'

const ConfigService = {
    configStepName (stepName, notificationText) {
        $httpCampaign.post('/rate-config/', {
            config_key: 'step_name_config',
            config_value: stepName
        }).then(() => {
            if (notificationText !== null && notificationText !== undefined) {
                window.vueapp.$appService.toastSuccess(notificationText)
            }
        })
    },
    getConfigStepName () {
        return $httpCampaign.get(`/rate-config/?config_key=step_name_config`)
    }
}
export default ConfigService
